module.exports = __webpack_public_path__ + "assets/img/block-0199f743.png";